import { render, staticRenderFns } from "./ListMessage.vue?vue&type=template&id=ebe091d0&"
import script from "./ListMessage.vue?vue&type=script&lang=ts&"
export * from "./ListMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports